import React, { useState } from 'react';
import "../css/resume.css";

const Resume = (props) => {
   return (
      <div className="resume-section">
         <div className="resume-section-content">
            <h1>Get my resume</h1>
            <a href="https://docs.google.com/document/d/1veTa-tQQ6mUFVCNVvfPY8J42EgFMlm7DMBx8no3hMx4/edit?usp=sharing" target="_blank">View in Google Drive</a>
         </div>
         <img id="resume-preview" src={props.resumePreview}></img>
      </div>
   );
}

export default Resume;